import { Link, useParams, Navigate } from 'react-router-dom'
import { PageShell } from '@components/layout/PageShell.js'
import { getWikiEntry } from '@content/wiki-entries.js'
import { ROUTES, wikiArticlePath } from '@utils/constants.js'

export function WikiArticlePage() {
  const { slug } = useParams<{ slug: string }>()
  const entry = slug ? getWikiEntry(slug) : undefined

  if (!entry) return <Navigate to={ROUTES.WIKI} replace />

  return (
    <PageShell>
      <nav className='cf3-wiki-article__nav'>
        <Link to={ROUTES.WIKI} className='cf3-wiki-article__back'>
          ← Enciclopédia
        </Link>
      </nav>

      <article className='cf3-wiki-article'>
        <span className='cf3-wiki-article__cat'>{entry.categoria}</span>
        <h1 className='cf3-wiki-article__title'>{entry.titulo}</h1>
        <p className='cf3-wiki-article__resumo'>{entry.resumo}</p>

        <section className='cf3-wiki-article__section'>
          <h2>O que é</h2>
          <p>{entry.oQueE}</p>
        </section>

        <section className='cf3-wiki-article__section'>
          <h2>Para que serve</h2>
          <p>{entry.paraQueServe}</p>
        </section>

        <section className='cf3-wiki-article__section'>
          <h2>Recomendações</h2>
          <ul>
            {entry.recomendacoes.map((r) => (
              <li key={r}>{r}</li>
            ))}
          </ul>
        </section>

        {entry.relacionados.length > 0 && (
          <section className='cf3-wiki-article__section'>
            <h2>Artigos relacionados</h2>
            <div className='cf3-wiki-article__related'>
              {entry.relacionados.map((rel) => {
                const related = getWikiEntry(rel)
                if (!related) return null
                return (
                  <Link
                    key={rel}
                    to={wikiArticlePath(rel)}
                    className='cf3-wiki-article__related-link'
                  >
                    {related.titulo}
                  </Link>
                )
              })}
            </div>
          </section>
        )}

        <div className='cf3-wiki-article__tags'>
          {entry.tags.map((t) => (
            <span key={t} className='cf3-wiki-article__tag'>
              {t}
            </span>
          ))}
        </div>
      </article>
    </PageShell>
  )
}
